export default __webpack_public_path__ + "static/media/banners_amazon_diciembre_coche_330x330.3dab0c31.jpg";